<template>
<div id="g-page" >
  
  <table border="0" class="main-table-screen" >
    <tr>
      <td id="main-table-row1" colspan="3"> 
      </td>
    </tr>

    <tr>
      <td></td>

      <td id="main-table-row2-dialog-container-td">

        <table border="0" class="dialog-table-radius">
          <tr>
            <td id="dialog-recover-password" align="center" >
              <table>
                <td id="dialog-recover-password-title">
                {{ $t("recoverpassword.title") }}
                </td>
              </table>
            </td>            
          </tr>

          <tr>
            <td class="dialog-input-field">
                {{ $t("recoverpassword.enterEmail") }}&nbsp;
            </td>
          </tr>
          
          <tr>
            <td class="dialog-input-field">
              <input type="text" class="dialog-input-email" ref="emailAddress" name="email" v-model="input.emailAddress" v-bind:placeholder="$t('recoverpassword.emailAddress')" maxlength="125" />
            </td> 
          </tr>

          <tr>
            <td class="dialog-input-field">
                {{ $t("recoverpassword.enterUsername") }}&nbsp;
            </td>
          </tr>

          <tr>
            <td class="dialog-input-field">
              <input type="text" class="dialog-input-email" ref="username" name="username" v-model="input.username" v-bind:placeholder="$t('recoverpassword.username')" maxlength="40" />
            </td> 
          </tr>

          <tr>
            <td class="dialog-input-field-buttons">  
              <input type="button" class="dialog-connect-input" v-on:click="goBack" v-bind:value="$t('recoverpassword.back')">
              <input type="button" class="dialog-connect-input" v-on:click="onSubmit" v-bind:value="$t('recoverpassword.submit')">
            </td>
          </tr>

        </table>

      </td>
      <td >
      </td>
    </tr>
    <tr>
      <td id="main-table-row3" colspan="3" > 
      </td>
    </tr>
  </table>

</div>

</template>

<script>

const { API } = require( '../../../api/member-api' + '?v=' + process.env.VUE_APP_VERSION )
import messageBox from './../common/message-box'
const { SUPPORT } = require( '../../../api/member-api' + '?v=' + process.env.VUE_APP_VERSION )

export default {
  name: 'recover-password',
  components: { },
  data() {
      return {
          input: {
              username: "",
              emailAddress: ""
          },
          isLoading:false
      }
  },
  methods: 
  {
    focusInput() {
      // SET DEFAULT CONTROL
      this.$refs.emailAddress.focus();
    },
    goBack(){
     // this.$router.push( { path: "/members/signon"} );
      SUPPORT.clearSession();
      this.$router.push( { path: "/" } );
      this.input.isLoading = false;
    },
    addEvents()
    {
      // RE-ADD EVENT HANDLER FOR ENTER KEY
      document.onkeyup = null;
      document.onkeyup = this.onEnterClicked;
    },
    onSuccess()
    {
      this.$router.push( { path: "/"} );
    },
    onSubmit(){

      if(this.input.isProcessing == true)
      {
        // ELIMINATE DUPLICATE CLICKS OR ENTER KEY STROKES
        return;
      }
      this.input.isProcessing = true;

      API.recoverPassword(this.input.emailAddress, 
                          this.input.username)
      .then(response => {          
        if(response.data.hasError == false)
        {
          this.$generalMessage(messageBox, this.$t("recoverpassword.success"), this.onSuccess);          
        } 
        else 
        {
          // FAILED TO AUTHENTICATE
          this.$generalMessage(messageBox, response.data.errorMessage, this.addEvents);
          this.isLoading = false;
        }
      })
      .catch(e => {
        this.$generalMessage(messageBox, e, this.addEvents);
      });  

      // ALLOW CLICKS AGAIN
      this.input.isProcessing = false;
    }
  },  
   
  mounted () {
    // SHOW TOP OF VIEW
    window.scrollTo(0, 0);
    // FOCUS ON THE USER NAME
    this.focusInput();
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/global.css";

// DISABLE WIDESCREEN BREAKPOINT
$widescreen-enabled: false;

// DISABLE FULLHD BREAKPOINT
$fullhd-enabled: false;

//////////////////////////////////////////
// MOBILE
@media only screen and 
(min-width : 320px) and (max-width : 1023px)
{
  // BEGIN SIGNON DIALOG STYLES
  .main-table-screen
  {
    background-color:gray;
    padding: 0px;
    margin: 0px;
    width:100%;
    margin-bottom:0px;
    display:table;
    max-width:100%;
    min-width:100%;
  }
  #main-table-row1
  {
    height:52px; 
  }
  #main-table-row2-dialog-container-td
  {
    width:90%;
    padding-left: 10%;
  }
  .dialog-table-radius
  {
    border-radius: 15px !important;
    overflow:hidden;
  }
  #dialog-recover-password
  {
    height:55px;
    background-color:#4682B4;
    color:white;
    font-family:'Arial Black';
    font-size: 15pt;
    font-style:italic;
    font-weight: bold;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align: bottom;
  }
  
  #dialog-recover-password-title
  {
    vertical-align:bottom;
    padding-left:8px
  }
  .dialog-input-field
  {
    height:30px;
    width:100%;
    text-align: center !important;
    vertical-align: middle;
    background-color:#343F68;
    color:white;
    padding-right:8px;
  }
  .dialog-input-email
  {
    width:100%;
    text-align: left !important;
    vertical-align: middle;
    /*background-color:#343F68;
    color:white;*/
  }
  .dialog-input-field-buttons
  {
    height:30px;
    width:100%;
    text-align: right !important;
    vertical-align: middle;
    background-color:#343F68;
    color:white;
    padding-right:8px;
  }
  /* .dialog-input-field
  {
    height:30px;
    width:100%;
    text-align: center !important;
    vertical-align: middle;
    background-color:#343F68;
    color:white;
  } */
  #dialog-connect-td
  {
    height: 50px;
    width:100%;
    vertical-align: middle !important;
    text-align: center;
    background-color:#343F68 ;
    //padding-right: 20px;
    padding-top: 15px;
  }
  .dialog-connect-input
  {
    color:white;
    background-color:#4682B4 ; 
    vertical-align: middle !important;   
  }
  #main-table-row3
  {
    height:250px;
  }
  
  
  // END SIGNON DIALOG STYLES
}

//////////////////////////////////////////
// DESKTOP
@media screen and (min-width:1024px)  
{
  // BEGIN SIGNON DIALOG STYLES
  .main-table-screen
  {
    background-color:gray;
    padding: 0px;
    margin: 0px;
    width:100%;
    margin-bottom:0px;
    display:table;
    max-width:100%;
    min-width:100%;
  }
  #main-table-row1
  {
    height:150px; 
  }
  #main-table-row2-dialog-container-td
  {
    width:33%;
  }
  .dialog-table-radius
  {
    border-radius: 15px !important;
    overflow:hidden;
  }
  #dialog-recover-password
  {
    height:40px;
    width:300px;
    background-color:#4682B4;
    color:white;
    font-family:'Arial Black';
    font-size: 15pt;
    font-style:italic;
    font-weight: bold;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align: bottom;
  }
  
  #dialog-recover-password-title
  {
    vertical-align:bottom;
    padding-left:8px
  }
  .dialog-input-field
  {
    height:40px;
    width:45%;
    text-align: center !important;
    vertical-align: middle;
    background-color:#343F68;
    color:white;
    padding-right:8px;
    //width:15%;
  }
  .dialog-input-email
  {
    width:80%;
    text-align: left !important;
    vertical-align: middle;
    /*background-color:#343F68;
    color:white;*/
  }
  .dialog-input-field-buttons
  {
    height:50px;
    width:100%;
    text-align: right !important;
    vertical-align: middle;
    background-color:#343F68;
    color:white;
    padding-right:8px;
  }
  /* .dialog-input-field-right
  {
    height:50px;
    width:55%;
    text-align: left !important;
    vertical-align: middle;
    background-color:#343F68;
    color:white;
  } */
  #dialog-connect-td
  {
    height: 50px;
    vertical-align: middle;
    text-align: right;
    background-color:#343F68 ;
    padding-right: 20px;
  }
  .dialog-connect-input
  {
    color:white;
    background-color:#4682B4 ;   
    vertical-align: middle !important;
  }
  #main-table-row3
  {
    height:250px;
  }
  
  // END SIGNON DIALOG STYLES

}
</style>